module.exports = __webpack_public_path__ + "img/mouse.9c52ade8.svg";